{
  "apexEnableQuadraticProgrammingFormulationMoveMode": false,
  "apexExplicitConfigSet": "",
  "apexFeatureImportances": false,
  "apexMaxCandidateGenerationTimeSeconds": 0,
  "apexNumCandidates": 0,
  "apexNumCandidatesToScanPerChildWorkflow": 0,
  "apexNumChildWorkflows": 0,
  "apexTargetIngredientDiversityCount": 0,
  "defaultDSIntermediates": false,
  "enableApex": false,
  "enableApexWorkspaces": false,
  "enableCatalystAgent": false,
  "enableCatalystAgentDebug": false,
  "enableCandidateViewOptions": false,
  "enableCombinedLabelsIngredientsTabs": false,
  "enableCreateRawMaterialFromPDF": false,
  "enableFeatureImpactPlots": false,
  "enableSearchSpaceCopyReconcileModal": false,
  "enableFeatureCustomization": false,
  "enableIngestTemplateDataset": false,
  "enableInsightsCopilotDemo": false,
  "enableMaterialsV3": false,
  "enableModelAssistant": true,
  "enableModelExplorerFlatFormulation": false,
  "enableMultiStepFilterByTags": false,
  "enablePredictionInsights": false,
  "enablePrivateDocuments": false,
  "enableSlProgressBranchSummary": false,
  "enableSnapshotsAsDataSources": false,
  "enableSupportChat": false,
  "enforceDataManagerDataset": false,
  "helpScoutBeacon": "18b86fd4-0d46-4db4-af6d-86df5bdde944",
  "maxFormulationDesignIngredients": 128,
  "maxFormulationNonzeroIngredients": 32,
  "maxMaterialsPaginationPageSize": 500,
  "maxMLModelOutputs": 32,
  "maxTerminalMaterialsInAnalysisWorkflowQuery": 5000,
  "predictorEvaluationResultDownsamplingLimit": 10000,
  "plotsPerAnalysisWorkflow": 10,
  "showSearchListCreation": false,
  "useTestApexConfig": false,
  "trialTermsUrl": ""
}
